const Cob = {
  symbol: 'cob',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-7h4.536l-2.272-3.957h-4.528L11.464 25H16zm-2.263-14.044h4.527L20.536 7h-9.072l2.272 3.957zm9.999 9.539L26 16.538h-4.536l-2.265 3.957h.001l2.263 3.958 2.273-3.957h-.002.002zM8.264 11.496L6 15.453h4.536l2.264-3.957-2.264-3.957-2.272 3.957zm4.535 9h.001l-2.264-3.958H6l2.264 3.957 2.272 3.958 2.264-3.957zm10.937-9l-2.273-3.957-2.264 3.957 2.264 3.957H26l-2.264-3.957z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#13bf99" r="16"/><path d="M16 25h-4.536l2.272-3.957h4.528L20.536 25H16zm-2.263-14.044h-.001L11.464 7h9.072l-2.272 3.956h-4.528zm9.999 9.539h-.002.002l-2.273 3.958-2.264-3.957h.001l2.263-3.958H26l-2.264 3.957zM8.264 11.496l2.272-3.957 2.264 3.957-2.264 3.956H6zm4.535 9h.001l-2.264 3.957-2.272-3.957L6 16.537h4.536l2.264 3.957zm10.937-9L26 15.453h-4.536l-2.265-3.957 2.264-3.957 2.273 3.957z" fill="#fff" fill-rule="nonzero"/></g>`;
  }
};
export default Cob;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/cob.js
// module id = null
// module chunks = 